import React from 'react'
import cn from 'classnames'

import Text from './Text'
import styles from './Clients.module.css'

const Client = ({ name }) => (
  <div className={cn([styles.client, styles[name]])} />
)

export default () => (
  <div className={styles.wrapper}>
    <div className={cn(styles.container, 'reveal')}>
      <h4>Friends</h4>
      <div className={styles.clients}>
        <Client name="klarna" />
        <Client name="tink" />
        <Client name="ica" />
        <Client name="volvo" />
        <Client name="viaplay" />
        <Client name="glue" />
        <Client name="ellos" />
        <Client name="nobina" />
        <Client name="travis" />
        <Client name="lifesum" />
        <Client name="supercoach" />
        <Client name="vint" />
      </div>
      <Text size="medium" className={styles.text}>
        These are just a few of the friends we’ve made during our journey so far. Would you like to be a part of this joyful family of pioneers in the digital world? Don’t be a stranger let’s have a <a href="https://m.me/madebybowtie">brew!</a>
      </Text>
    </div>
  </div>
)



// WEBPACK FOOTER //
// ./src/components/Clients.js